import { Container, Spinner } from '@my/ui'
import { MainLayout } from 'app/components'
import React, { useState } from 'react'
import { FreshersScreen } from './freshers-screen'
import { useFreshersPageQuery } from './queries'

export interface FreshersScreenContainerProps {
  preview?: boolean
}

export const FreshersScreenContainer = (props: FreshersScreenContainerProps) => {
  const [refreshing, setRefreshing] = useState(false)

  const { loading, data, refetch } = useFreshersPageQuery({
    draft: !!props.preview,
  })

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetch()])
    setRefreshing(false)
  }

  if (loading || !data) {
    return (
      <MainLayout>
        <Container flex={1} justifyContent="center">
          <Spinner size="large" />
        </Container>
      </MainLayout>
    )
  }
  return (
    <FreshersScreen
      article={data.FreshersPage}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
